import { CreateAxiosDefaults } from "axios";

export const serviceDefaultConfig: CreateAxiosDefaults = {
    baseURL: import.meta.env.VITE_APP_BASE_API,
    timeout: 30 * 1000,
}

/**
 * 请求数据平台
 */
export const PLATFORM = 'PC'